import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function RequireAdmin({ children }) {
  const { isLoggedIn, user, bootstrapping } = useAuth();
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-700 mx-auto"></div>
          <p className="mt-4 text-slate-700 font-medium">Oturum kontrol ediliyor...</p>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // Admin paneli erişimi DB'deki ham role'a bağlıdır (TB-047 alias'ından bağımsız).
  // BAŞKAN rolü API'de 'admin' alias'lanır ama userRoleRaw='baskan' kalır → admin paneline giremez.
  if ((user?.userRoleRaw || "") !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}
